import { render, staticRenderFns } from "./CarResults.vue?vue&type=template&id=24c54c0c&scoped=true&"
import script from "./CarResults.vue?vue&type=script&lang=js&"
export * from "./CarResults.vue?vue&type=script&lang=js&"
import style0 from "./CarResults.vue?vue&type=style&index=0&id=24c54c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c54c0c",
  null
  
)

export default component.exports